import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { Block, Navbar, Page, Preloader } from "framework7-react";
import {
  joinGroup,
  refreshGroups,
  showGroup,
} from "../redux/reducer/app-slice";
import { useToast } from "../hooks/use-toast";
import { promptAssignment } from "../features/assign-me/assign-prompt";

const JoinLink = ({ f7route, f7router }) => {
  const code = f7route?.params?.code || "";
  const dispatch = useDispatch();
  const { showToast } = useToast();
  const started = useRef(false);

  useEffect(() => {
    // StrictMode runs effects twice; join only once.
    if (started.current) return;
    started.current = true;

    const goHome = () =>
      f7router.navigate("/", { reloadAll: true, animate: false });

    dispatch(
      joinGroup(
        code,
        (group) => {
          promptAssignment(group.id);
          dispatch(showGroup(group));
          dispatch(refreshGroups());
          goHome();
        },
        (errorMessage) => {
          showToast({
            text: errorMessage || "Der Gruppe konnte nicht beigetreten werden.",
            closeTimeout: 3000,
            cssClass: "color-red",
          });
          goHome();
        },
      ),
    );
  }, [code, dispatch, f7router, showToast]);

  return (
    <Page>
      <Navbar title="Gruppe beitreten" />
      <Block className="text-align-center">
        <Preloader />
        <p>Du trittst der Gruppe bei …</p>
      </Block>
    </Page>
  );
};

export default JoinLink;
